import React from "react";

/**
 * Spark logo component — uses the public favicon.svg as a tiny visual anchor.
 * Sizes via the `size` prop (defaults to 24px). Pure presentational.
 */
export default function Logo({ size = 24, className = "", glow = false, alt = "Spark" }) {
  return (
    <img
      src="/favicon.svg"
      width={size}
      height={size}
      alt={alt}
      className={`inline-block select-none ${className}`}
      draggable={false}
      style={glow ? { filter: "drop-shadow(0 0 12px rgba(201,169,97,0.5))" } : undefined}
    />
  );
}
